const SUBCONTRACTOR_STATUSES = {
  ACTIVE: "active",
  INVITE_SENT: "invite sent",
  SUSPENDED: "suspended",
  NO_ACCESS: "no access"
}

const subcontractorStatusOptions = [
  { label: "Active", value: SUBCONTRACTOR_STATUSES.ACTIVE },
  { label: "Invite Sent", value: SUBCONTRACTOR_STATUSES.INVITE_SENT },
  { label: "Suspended", value: SUBCONTRACTOR_STATUSES.SUSPENDED },
  { label: "No Access", value: SUBCONTRACTOR_STATUSES.NO_ACCESS }
]

const subcontractorStatusColorMap = {
  [SUBCONTRACTOR_STATUSES.ACTIVE]: "green",
  [SUBCONTRACTOR_STATUSES.INVITE_SENT]: "gold",
  [SUBCONTRACTOR_STATUSES.SUSPENDED]: "red",
  [SUBCONTRACTOR_STATUSES.NO_ACCESS]: "default"
}

const subcontractorEditableStatuses = [
  SUBCONTRACTOR_STATUSES.NO_ACCESS,
  SUBCONTRACTOR_STATUSES.INVITE_SENT
]

export {
  SUBCONTRACTOR_STATUSES,
  subcontractorStatusOptions,
  subcontractorStatusColorMap,
  subcontractorEditableStatuses
}
